import axios, { type AxiosInstance } from 'axios'
import axiosRetry from 'axios-retry'
import isRetryAllowed from 'is-retry-allowed'

let axiosSingleton: AxiosInstance | null = null

export const axiosInstance = (): AxiosInstance => {
  if (axiosSingleton) {
    return axiosSingleton
  }

  axiosSingleton = axios.create({
    headers: {
      'Content-Type': 'application/json',
    },
    // if local .NET environment during development, increase timeout limit
    timeout: window.location.href.toLowerCase().includes('nopperoyal.public') ? 600000 : 10000,
  })

  axiosRetry(axiosSingleton, {
    retries: 10,
    retryCondition: (error) =>
      error.code !== 'ECONNABORTED' && // Prevents retrying timed out requests
      isRetryAllowed(error), // Check whether a request can be retried based on the error.code
    retryDelay: () => 1000,
  })

  return axiosSingleton
}
